/** Lowercased, with quotes, punctuation and spaces gone, so two spellings of one phrase compare equal. */
const plain = (s: string) => s.toLowerCase().replace(/[\p{P}\p{S}\s\p{Cf}]+/gu, '');

/** What may be left of a note once the word and the meaning are taken out (a dash, "means", "a"), in plain characters. */
const LEFTOVER_MAX = 10;

/**
 * Whether an explain note only says the word and its right meaning again, which a sign
 * already shows in its thumb zone. False when either is empty, so a note is never lost by accident.
 */
export function explainRepeats(explain: string, word: string, meaning: string): boolean {
  const e = plain(explain), w = plain(word), m = plain(meaning);
  if (!w || !m || !e.includes(w) || !e.includes(m)) return false;
  // The longer of the two goes first, so a meaning that holds the word is not counted twice.
  const [a, b] = w.length >= m.length ? [w, m] : [m, w];
  return e.replace(a, '').replace(b, '').length <= LEFTOVER_MAX;
}
